import {
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  Grid,
  Dialog,
  Select,
  MenuItem,
  Radio,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import { style } from "@mui/system";
import useStyles from "./styles";
import OtpInput from "react-otp-input";
import { LoggerClass as Logger } from "utils/logger";

type Props = {};
const PaymentStatusDialog = ({
  showPopup,
  closePopup = () => {},
  handleClose = () => {},
  handleSelect,
}) => {
 
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const [otp, setOtp] = useState("");
  const [disable, setDisable] = useState(true);
  const [selectedCheck, setSelectedCheck] = useState<any>([]);

  const close = () => {
    setShow(false);
    closePopup();
  };

  useEffect(() => {
    if (otp?.length === 4) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [otp?.length]);

  useEffect(() => {
    setSelectedCheck([]);
    setShow(showPopup);
  }, [showPopup]);

  return (
    <Dialog open={show} className={styles.popup}>
      <Box sx={{ display: "flex", flexDirection: "column", margin: "16px" }}>
        
      <img
          src={require("../../../../../assets/check_yellow.png")}
          alt=""
          style={{
            height: 110,
            width: 86,
            alignSelf:'center'
          }}
          onClick={()=>{}}
        />

        <div
          style={{
            fontFamily: "Open Sans",
            fontSize: 18,
            color: "#192342",
            fontWeight: "600",
            textAlign: "center",
            marginTop: -20
          }}
        >
          Rental payment  has been successfully processed.   
          
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 25,
          }}
        >
          <Button
            className={styles.signInButton}
            onClick={() => {
              handleSelect(false);
            }}
            style={{ marginLeft: 0 }}
            
          >
            Continue
          </Button>

         
        </div>
      </Box>
    </Dialog>
  );
};

export default PaymentStatusDialog;
